<div class="survey-overlay">
  <div class="survey-modal" (click)="$event.stopPropagation()">
    <div class="close-container">
      <button class="close-btn" (click)="close()">
        <lucide-icon name="X" [size]="20"> </lucide-icon>
      </button>
    </div>
    <div class="survey-header">
      <div class="header-content">
        <h2 class="survey-title">
          {{ survey.campaignName }}
        </h2>
        <p class="survey-description">
          {{ survey.campaignDetail }}
        </p>
      </div>
    </div>

    <div class="score-container">
      <button
        class="emoji-btn"
        *ngFor="let item of survey.campaignScore"
        [class.selected]="selectedScore === item.score"
        [style.--emoji-color]="item.color"
        (click)="selectScore(item.score)"
      >
        <span class="emoji">
          {{ item.emoji }}
        </span>

        <span class="emoji-label">
          {{ item.short }}
        </span>
      </button>
    </div>

    <div *ngIf="isLowScore" class="feedback-wrapper">
      <div class="feedback-header">
        <h3>¿Qué podemos mejorar?</h3>

        <span> {{ feedback.length }}/{{ maxChars }} </span>
      </div>

      <textarea
        [(ngModel)]="feedback"
        [maxLength]="maxChars"
        rows="5"
        placeholder="Cuéntanos qué ha ocurrido..."
      >
      </textarea>
    </div>

    <div class="survey-actions">
      <p-button
        label="Enviar respuesta"
        severity="primary"
        [disabled]="!canSubmit"
        [style]="{ width: '100%' }"
        (onClick)="onSubmit()"
      >
      </p-button>

      <p-button
        label="Omitir encuesta"
        severity="secondary"
        outlined="true"
        [style]="{ width: '100%' }"
        (onClick)="skipSurvey()"
      >
      </p-button>
    </div>
  </div>
</div>
